import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";

function SelectedFilesDialogRaw(props) {
  const { onClose, items, open, removeItem, ...other } = props;

  return (
    <Dialog sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }} maxWidth="xs" open={open} {...other}>
      <DialogTitle>
        Selected Items
        <IconButton sx={{ position: "absolute", right: 12, top: 12, color: "black" }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "5px" }} dividers>
        <List dense>
          {items.map((item) => (
            <ListItem
              sx={{ wordBreak: "break-all" }}
              divider
              key={item}
              secondaryAction={
                <IconButton onClick={() => removeItem(item)} size="small" edge="end" aria-label="close">
                  <CloseIcon />
                </IconButton>
              }
            >
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SelectedFilesDialogRaw.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

const SelectedFilesDialog = ({ children, selectedRows, removeItem }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickListItem = () => setOpen(true);
  const handleClose = () => setOpen(false);

  React.useEffect(() => {
    if (selectedRows.length === 0) handleClose();
  }, [selectedRows.length]);

  if (selectedRows.length === 0) return children;

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        aria-haspopup="true"
        aria-controls="selected-files-menu"
        onKeyDown={handleClickListItem}
        onClick={handleClickListItem}
      >
        {children}
      </span>
      <SelectedFilesDialogRaw
        id="selected-files-menu"
        items={selectedRows}
        removeItem={removeItem}
        keepMounted
        open={open}
        onClose={handleClose}
      />
    </>
  );
};

export default React.memo(SelectedFilesDialog);
